// src/components/common/Pagination.js
import React from 'react';
import { usePagination, DOTS } from '../../hooks/usePagination';

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => onPageChange(currentPage + 1);
  const onPrevious = () => onPageChange(currentPage - 1);
  const lastPage = paginationRange[paginationRange.length - 1];
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalCount);

  return (
    <div className="pagination">
      <span className="page-info">
        {startItem}–{endItem} of {totalCount}
      </span>
      <button
        type="button"
        className="page-btn"
        disabled={currentPage === 1}
        onClick={onPrevious}
        aria-label="Previous page"
      >
        ‹
      </button>
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return (
            <span key={`dots-${index}`} className="page-info" style={{ marginRight: 0 }}>
              …
            </span>
          );
        }
        return (
          <button
            type="button"
            key={pageNumber}
            className={`page-btn${pageNumber === currentPage ? ' active' : ''}`}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </button>
        );
      })}
      <button
        type="button"
        className="page-btn"
        disabled={currentPage === lastPage}
        onClick={onNext}
        aria-label="Next page"
      >
        ›
      </button>
    </div>
  );
};

export default Pagination;
